import {ActionContext} from 'vuex';
import {api} from '@/api';
import {AdditionalDiscounts, GetAdditionalDiscountsRequest, Mall} from 'supporter';
import {MallSelectItem} from '@/types/promotion';

interface PromotionState {
  malls: Mall[];
  additionalDiscounts: AdditionalDiscounts;
}

export default {
  namespaced: true,

  state: {
    malls: [],
    additionalDiscounts: {
      totalCount: 0,
      contents: []
    }
  },

  getters: {
    additionalDiscounts(state: PromotionState): AdditionalDiscounts {
      return state.additionalDiscounts;
    },
    sortedAdditionalDiscountsByDate(state: PromotionState): AdditionalDiscounts {
      const sortedAddionalDiscounts = {
        ...state.additionalDiscounts,
        contents: [...state.additionalDiscounts.contents].sort((a, b) => {
          return new Date(b.registerYmdt).getTime() - new Date(a.registerYmdt).getTime();
        })
      };

      return sortedAddionalDiscounts;
    },
    mallSelectList(state: PromotionState): MallSelectItem[] {
      return [{value: '', name: '전체'}].concat(state.malls.map(mall => ({value: mall.mallNo.toString(), name: mall.mallName})));
    }
  },

  mutations: {
    SET_ADDITIONAL_DISCOUNTS(state: PromotionState, data: AdditionalDiscounts): void {
      state.additionalDiscounts = data;
    },

    SET_MALLS(state: PromotionState, data: Mall[]): void {
      state.malls = data;
    }
  },

  actions: {
    async fetchAdditionalDiscounts({state, commit, rootState}: ActionContext<PromotionState, any>, payload: GetAdditionalDiscountsRequest): Promise<void> {
      const additionalDiscountsResponse = await api.getAdditionalDiscounts(payload);

      commit('SET_MALLS', rootState.mall.malls);
      commit('SET_ADDITIONAL_DISCOUNTS', additionalDiscountsResponse.data);
    }
  }
};
